export default __webpack_public_path__ + "static/media/politur-transfer.c6a05313.ico";